import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { DeleteToneRequest } from '../api/tune/deletetone/deletetonerequest';
import { DeleteToneResponse, DeleteToneResponseDtoImpl } from '../api/tune/deletetone/deletetoneresponse';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { SixdeeCRBTAPIProcessor } from './sixdeecrbtapiprocessor';
import { Strings } from '../../utils/resources/strings';

export class DeleteToneAPIProcessorImpl extends SixdeeCRBTAPIProcessor<DeleteToneRequest, DeleteToneResponse>
{
    execute(request: DeleteToneRequest): void 
    {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new DeleteToneResponseDtoImpl(APIFeatures.DELETE_TONE, "Delete Tone Success");

                this.getAPISuccess(response);
            }
        }
        catch (e) {
            this.getAPIFailure(new DeleteToneResponseDtoImpl(APIFeatures.DELETE_TONE, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        super.onFailure(responseMapper);
  
            this.getAPIFailure(new DeleteToneResponseDtoImpl(APIFeatures.DELETE_TONE, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/deletetoneapiprocessor.tsx